<template>
  <div class="form">
    <form-field type="tel"
                label="Verification code"
                :required="true"
                v-model="code"
                :validate="validateCode"
                :focus="focused"
                @submit="submit">
    </form-field>
    <form-button pull="right"
                 color="blue"
                 @click="submit">
      Verify
    </form-button>
  </div>
</template>

<script>
import FormButton from '../elements/FormButton';
import FormField from '../elements/FormField';

function strip(code) {
  return code.replace(/[- _.,+]/g, '');
}

export default {
  components: {
    FormButton,
    FormField,
  },

  data() {
    return {
      code: '',
      focused: true,
    };
  },

  methods: {
    validateCode: code => /^\d{6}$/.test(strip(code)),

    submit() {
      if (this.code) {
        this.$emit('submit', {
          code: strip(this.code),
        });
      } else {
        this.focused = false;
        this.$nextTick(() => { this.focused = true; });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forms/VerificationCode.vue